enum CLOCK_STEP {
  CASE_WORK = 'case_work',
  EN_ROUTE = 'en_route',
  ON_SCENE = 'on_scene',
}

enum MANAGEMENT_BUCKET {
  DAY = 'day',
  HOUR = 'hour',
  MONTH = 'month',
  WEEK = 'week',
  YEAR = 'year',
}

enum MANAGEMENT_CARD {
  ACTIVITY = 'activity',
  AGING = 'aging',
  BREAKDOWN = 'breakdown',
  BUSY_TIMES = 'busyTimes',
  CANCELLED = 'cancelled',
  GEOGRAPHY = 'geography',
  OUTCOMES = 'outcomes',
  SUMMARY = 'summary',
  TIME_BY_OFFICER = 'timeByOfficer',
  TIMELINESS = 'timeliness',
  TREND = 'trend',
}

enum MANAGEMENT_COMPARE {
  NONE = 'none',
  PREVIOUS_PERIOD = 'previous_period',
  PREVIOUS_YEAR = 'previous_year',
}

enum MANAGEMENT_PRESET {
  CUSTOM = 'custom',
  LAST_12_MONTHS = 'last_12_months',
  LAST_30_DAYS = 'last_30_days',
  LAST_7_DAYS = 'last_7_days',
  THIS_MONTH = 'this_month',
  THIS_QUARTER = 'this_quarter',
  THIS_WEEK = 'this_week',
  THIS_YEAR = 'this_year',
  TODAY = 'today',
  YESTERDAY = 'yesterday',
}

enum OFFICER_CASES_FILTER {
  ACTIVE = 'active',
  SCHEDULED = 'scheduled',
}

enum OFFICER_STATUS {
  ONLINE = 'online',
  OUT_OF_SERVICE = 'out_of_service',
  OFFLINE = 'offline',
}

/** Overdue is never stored: see `is_overdue`. */
enum SCHEDULED_ACTIVITY_STATUS {
  CANCELED = 'canceled',
  COMPLETED = 'completed',
  SCHEDULED = 'scheduled',
}

enum SCHEDULE_COLOR_MODE {
  OFFICER = 'officer',
  STATUS = 'status',
}

export {
  CLOCK_STEP,
  MANAGEMENT_BUCKET,
  MANAGEMENT_CARD,
  MANAGEMENT_COMPARE,
  MANAGEMENT_PRESET,
  OFFICER_CASES_FILTER,
  OFFICER_STATUS,
  SCHEDULE_COLOR_MODE,
  SCHEDULED_ACTIVITY_STATUS,
};
